export default {"src":"/_next/static/media/link-circle-fill.56f7711f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};